import * as urlUtils from 'utils/Url';


export function getPathControlWorkflowPlaybooks(qs={}) {
  return urlUtils.appendQueryString(`/control/workflow-playbooks`, qs);
}

export function getPathControlAddWorkflowPlaybook() {
  return `/control/workflow-playbooks/add`;
}

export function getPathControlEditWorkflowPlaybook(playbookId) {
  return `/control/workflow-playbooks/${playbookId}/edit`;
}

export function getPathControlReplicateWorkflowPlaybook(playbookId) {
  return `/control/workflow-playbooks/${playbookId}/replicate`;
}
